import { AbstractControl } from '@angular/forms';
import { RenovationDetail } from '@smartflip/data-models';

export const getRenovationDetails = (
  renovationFormControls: AbstractControl<RenovationDetail>[],
) => renovationFormControls.map((control) => control.value);
